import { Button } from '@/components/ui/button';

export const OnDemandUsageCard = () => {
    const current = 67;
    const limit = 500;
    const percentage = (current / limit) * 100;

    return (
        <div className="bg-gray-900/5 rounded-xl p-4 border border-gray-200/50 w-full max-w-sm">
            <div className="flex justify-between items-center mb-2">
                <span className="text-sm font-medium text-gray-600">
                    <span className="text-gray-900 font-bold">${current}</span> / ${limit}
                </span>
            </div>

            {/* Progress Bar */}
            <div className="h-1.5 w-full bg-gray-200 rounded-full overflow-hidden mb-3">
                <div
                    className="h-full bg-violet-500 rounded-full"
                    style={{ width: `${percentage}%` }}
                />
            </div>

            <div className="flex justify-between items-center">
                <span className="text-xs text-gray-500 font-medium">Consumo on-demand este mes</span>
                <Button
                    variant="outline"
                    size="sm"
                    disabled
                    title="Disponible próximamente"
                    className="h-7 text-xs border-gray-300 text-gray-400 bg-white opacity-60 cursor-not-allowed"
                >
                    Cambiar límite
                </Button>
            </div>
            {/* Audit C-13: aclaramos qué representa este límite (es plata). */}
            <p className="text-[11px] text-gray-400 mt-2 leading-relaxed">
                Tope de gasto extra facturable por mes. Si lo superás, pausamos los envíos on-demand.
            </p>
        </div>
    );
};
